import { Clock, DollarSign, PhoneOff, AlertTriangle } from "lucide-react";
import { PROBLEMS } from "../data/mock";

const iconMap = {
  Clock,
  DollarSign,
  PhoneOff,
};

export const ProblemSection = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-red-50 border border-red-100/80 rounded-full px-4 py-1.5 mb-6">
            <AlertTriangle size={13} className="text-hevi-red" />
            <span className="text-hevi-red font-semibold text-[11px] uppercase tracking-[0.15em]">
              {PROBLEMS.label}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold text-navy-900 leading-tight mb-5">
            YOUR CURRENT CARRIER IS{" "}
            <span className="text-hevi-red">COSTING YOU MORE</span>{" "}
            THAN YOU THINK
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            {PROBLEMS.subheadline}
          </p>
        </div>

        {/* Problem Cards */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-7">
          {PROBLEMS.cards.map((card, i) => {
            const Icon = iconMap[card.icon];
            return (
              <div
                key={i}
                className="group relative bg-white rounded-2xl p-8 border border-slate-200/60 card-premium hover:shadow-xl transition-all duration-500 overflow-hidden"
              >
                {/* Top accent line on hover */}
                <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-hevi-red/70 via-hevi-red to-hevi-red/70 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-center rounded-b" />
                
                <div className="w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center mb-6 group-hover:bg-red-100/80 transition-colors duration-300">
                  {Icon && <Icon size={26} className="text-hevi-red" />}
                </div>
                <h3 className="text-lg font-bold text-navy-900 mb-3">
                  {card.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-[14.5px]">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
